'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconList = require('./iconList');

var _iconList2 = _interopRequireDefault(_iconList);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroIcon = function NitroIcon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      variant = _ref.variant,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom,
      action = _ref.action,
      clickable = _ref.clickable,
      alignment = _ref.alignment,
      hoverVariant = _ref.hoverVariant,
      shadow = _ref.shadow,
      currentColor = _ref.currentColor,
      className = _ref.className,
      pointerEvents = _ref.pointerEvents;

  var Icon = _iconList2.default[name];
  var cursor = action || clickable ? 'pointer' : 'inherit';

  return _react2.default.createElement(
    _styles.IconContainer,
    {
      pointerEvents: pointerEvents,
      size: size,
      variant: variant,
      left: left,
      right: right,
      top: top,
      bottom: bottom,
      onClick: action,
      cursor: cursor,
      alignment: alignment,
      hoverVariant: hoverVariant,
      shadow: shadow,
      currentColor: currentColor,
      className: className
    },
    Icon && _react2.default.createElement(
      'svg',
      {
        className: 'icon',
        width: size + 'px',
        height: size + 'px',
        viewBox: '0 0 500 500'
      },
      _react2.default.createElement(Icon, null)
    )
  );
};

NitroIcon.propTypes = {
  name: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  variant: _propTypes2.default.string,
  left: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  right: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  top: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  bottom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  action: _propTypes2.default.func,
  clickable: _propTypes2.default.bool,
  alignment: _propTypes2.default.bool,
  hoverVariant: _propTypes2.default.string,
  shadow: _propTypes2.default.bool,
  currentColor: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  pointerEvents: _propTypes2.default.string
};

NitroIcon.defaultProps = {
  size: 16,
  variant: 'base2'
};

exports.default = NitroIcon;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/NitroIcon.js
// module id = 3010
// module chunks = 4